import React from 'react';
export default {
  'cart': {
    'change-currency': '更改货币',
    'and-then': '然后',
    'plus-tax': ' + 税',
    'for': '为期',
    'edit': {
      'label': '编辑',
      'submit': '应用'
    },
    'empty': '您还没有在订单中添加任何商品。',
    'free': '免费',
    'promo-code': {
      'add': '添加礼品卡或促销代码',
      'error': {
        'invalid-for-subscription': '优惠券代码对此订单无效。'
      },
      'label': '礼品卡或促销代码',
      'submit': '应用'
    },
    'subtotal-line': {
      'tax-label': '估计税费',
      'subtotal': '小计',
      'tax': '税费',
      'gift-card': '礼物卡'
    },
    'starting-price': '起始价',
    'title': '订单摘要',
    'setup-fee': '设置费',
    'free-trial': '免费试用',
    'total-line': {
      'label': '总计'
    },
    'order-total-line': {
      'label': '订单总额'
    }
  },
  'address': {
    'country': '国家',
    'address2': '公寓、套房等',
    'tax-identifier': '税务识别符',
    'tax-identifier-type': '税务识别符类型',
    'first-name': '名字',
    'last-name': '姓',
    'company-name': '公司名称',
    'address1': '街道地址',
    'city': '城市',
    'state': '省',
    'postal-code': '邮政编码',
    'phone-number': '电话号码',
    'vat-number': '增值税号/税务编号'
  },
  'payment-method': {
    'credit-card': {
      'label': '银行卡详细信息',
      'expiry': '月月/年年',
      'name': '信用卡',
      'number': '卡号',
      'cvv': 'CVV',
      'brand': {
        'visa': 'Visa',
        'master': 'MasterCard',
        'cartes_bancaires': 'Cartes Bancaires'
      }
    },
    'ach': {
      'name': '银行账户',
      'routing-number': '路由号码',
      'account-number': '账户号码',
      'account-number-confirmation': '确认账户号码',
      'account-type': {
        'label': '账户类型',
        'checking': '支票账户',
        'savings': '储蓄账户'
      },
      'name-on-account': '账户持有人姓名'
    },
    'amazon': {
      'name': 'Amazon Pay'
    },
    'apple-pay': {
      'name': 'Apple Pay'
    },
    'boleto': {
      'name': 'Boleto'
    },
    'bacs': {
      'name': 'Bacs',
      'sort-code': 'Sort代码'
    },
    'becs': {
      'name': 'BECS',
      'bsb-code': 'BSB代码'
    },
    'google-pay': {
      'name': 'Google Pay'
    },
    'ideal': {
      'name': 'Ideal'
    },
    'paypal': {
      'name': 'PayPal'
    },
    'qiwi_wallet': {
      'name': 'Qiwi Wallet'
    },
    'sepa': {
      'name': 'SEPA',
      'iban': 'IBAN号码'
    },
    'sofort': {
      'name': 'Sofort'
    },
    'venmo': {
      'name': 'Venmo'
    }
  },
  'billing-address': '账单地址',
  'billing-address-same-as-shipping': '与收货地址相同',
  'submit': '立即付款',
  'payment-method-selected': ({ paymentMethod }: { paymentMethod: string }) => <>已选择{paymentMethod}</>,
  'express-checkout': '快速结账',
  'change-payment-method': '更改支付方式',
  'day': '天',
  'days': '天',
  'week': '周',
  'weeks': '周',
  'month': '月',
  'months': '月',
  'year': '年',
  'years': '年',
  'confirmation': {
    'title': '感谢您的预订',
    'order-num': ({ number }: { number: number }) => <>订单 #{number}</>,
    'fulfilled-on': ({ date }: { date: string }) => <>完成于{date}</>,
    'email-notice': '您将收到一封有关您订单的确认电子邮件。',
    'payment': '付款',
    'return-to': ({ name }: { name: string }) => <>返回{name}</>,
    'credit-applied': '积分已应用'
  },
  'back': '返回',
  'contact-info': '联系信息',
  'email-address': '电子邮件',
  'payment-info': '账单信息',
  'shipping-address': '收货地址',
  'legal': {
    'accept': '我接受',
    'privacy-policy': '隐私政策',
    'terms-of-service': '服务条款'
  },
  'recurring': {
    'consent': '我同意定期支付上述费用（计费频率如上所示），除非我在当前计费周期结束前取消订阅。',
    'cancel': '如需取消订阅，请访问您的“账户管理”页面。'
  },
  'pluralize': {
    'days': ({ count }: { count: number }) => count === 1 ? '天' : '天',
    'weeks': ({ count }: { count: number }) => count === 1 ? '周' : '周',
    'months': ({ count }: { count: number }) => count === 1 ? '月' : '月',
    'years': ({ count }: { count: number }) => count === 1 ? '年' : '年'
  },
  'subscription': {
    'details': {
      'addons': {
        'flat.charge': ({ amount, addOnName }: { amount: string; addOnName: string }) => <>您将被收取{amount}/单位，用于{addOnName}</>,
        'no-flat.charge': ({ amount, units, unitsLabel, addOnName }: { amount: string; units: number; unitsLabel: string; addOnName: string }) => <>您将被收取{amount}用于{units} {unitsLabel}的{addOnName}</>
      },
      'billing.starting': ({ startDate, amount, intervalLengthLabel, taxable = true }: { startDate: string; amount: string; intervalLengthLabel: string; taxable?: boolean }) => <>从{startDate}开始，您将被计费{amount}/{intervalLengthLabel}{taxable ? ' + 税' : ''}</>,
      'billing.starting.setupfee': ({ startDate, amount, intervalLengthLabel, setupFee, taxable = true }: { startDate: string; amount: string; intervalLengthLabel: string; setupFee: string; taxable?: boolean }) => <>从{startDate}开始，您将被计费{amount}/{intervalLengthLabel}{taxable ? ' + 税' : ''}，以及一次性费用{setupFee}</>,
      'cancellation.reminder': ({ days }: { days: number }) => `您将在账单开始前${days}天收到电子邮件提醒。`,
      'trial.start': ({ trialLength, trialInterval }: { trialLength: string; trialInterval: string }) => <>您的免费{trialLength} {trialInterval}试用今天开始。</>,
      'trial.ends': ({ trialEndsAt }: { trialEndsAt: string }) => <>为避免被收费，您必须在{trialEndsAt}之前取消。</>,
      'email.reminder': ({ days }: { days: number }) => <>您将在账单开始前{days}天收到电子邮件提醒</>,
      'no-renewal': ({ billingEndsAt }: { billingEndsAt: string }) => <>您的订阅将在{billingEndsAt}结束，不会自动续订。</>,
      'ramp.after': ({ afterChargeTime, newChargeAmount }: { afterChargeTime: string; newChargeAmount: string }) => <>{afterChargeTime}后，您将被收取{newChargeAmount} + 税</>,
      'renewal': ({ totalCyclesLengthLabel }: { totalCyclesLengthLabel: string }) => <>您的订阅将每{totalCyclesLengthLabel}自动续订，并持续到您取消为止。</>,
      'title': '订阅详情',
    },
    'agreement.button': '同意并继续',
    'agreement.text': '点击"同意并继续"，您确认理解并接受这些订阅条款。在您完成结账之前不会产生任何费用。',
    'changeOrCancel': '要更改或取消您的订阅，请',
    'access-account': '访问您的账户',
    'contact-support': '联系客服',
  },
  'currency-display': ({ currency }: { currency: string }) => <>{(currency || '').toUpperCase()}</>,
  'support': {
    'array': {
      'wordsConnector': ', ',
      'twoWordsConnector': ' 和 ',
      'lastWordConnector': ', 和 '
    }
  },
  'powered-by': ({ recurly }: { recurly: string }) => <>订阅计费由{recurly}提供支持</>,
  'errors': {},
  'subscribe': '订阅'
};
